const e={exists:e=>!!window.localStorage.getItem(e),get:e=>window.localStorage.getItem(e),set:(e,t)=>window.localStorage.setItem(e,t),delete:e=>window.localStorage.removeItem(e)};export{e as default};
